import fetch from '../../utils/fetch'

export function getRecordByPlateNo(params) {
    return fetch({
        url: '/api/parkrec/venue',
        method: 'GET',
        params
    })
}

export function order(params) {
    // 统一在下单接口注入 UA，便于排查特殊容器/浏览器下支付平台判断异常的问题
    // Object.assign(默认值, params)：调用方若显式传了 UA 则以调用方为准
    console.log('测试UA', params)
    const data = Object.assign(
        {
            userAgent: (typeof navigator !== 'undefined' && navigator.userAgent) || ''
        },
        params
    );
    return fetch({
        url: '/api/order',
        method: 'POST',
        data: data
    })
}
export function getParkinglotInfo(id) {
    return fetch({
    url: '/api/parkinfo/' + id,
        method: 'GET',
    })
}

export function pay(params) {
    return fetch({
        url: '/api/pay/unionOrder',
        method: 'POST',
        data: params
    })
}

export function getPrecomputation(params) {
    return fetch({
        url: '/api/feescale/precomputation',
        method: 'GET',
        params
    })
}

